import React, { useMemo } from "react";
import Chart from "react-apexcharts";

// Konstanta nama bulan
const MONTH_NAMES = [
    "Januari", "Februari", "Maret", "April",
    "Mei", "Juni", "Juli", "Agustus",
    "September", "Oktober", "November", "Desember"
];

// Formatter nilai ke juta
const formatToJuta = (val, locale, suffix = " Juta") =>
    (val / 1_000_000)?.toLocaleString(locale, { maximumFractionDigits: 0 }) + suffix;

// Formatter currency ke juta
const formatCurrencyToJuta = (val, locale, currency) =>
    (val / 1_000_000)?.toLocaleString(locale, {
        style: "currency",
        currency,
        maximumFractionDigits: 2
    });

export default function NilaiExportChart({
    data = [],
    xAxis = 2,
    colors = ["#F59E0B", "#3B82F6"]
}) {
    const chartConfig = useMemo(() => {
        if (!Array.isArray(data) || data.length === 0) return null;

        const categories = xAxis === 1
            ? data.map(item => item?.TANGGAL || "-")
            : data.map(item => MONTH_NAMES[item?.BULAN - 1] || "-");

        return {
            options: {
                chart: {
                    fontFamily: '"Inter", sans-serif',
                    toolbar: { show: false }
                },
                colors,
                stroke: { curve: "smooth", width: 3 },
                dataLabels: { enabled: false },
                legend: { show: true },
                xaxis: {
                    categories,
                    labels: { style: { colors: "#8A92A6" } }
                },
                yaxis: [
                    {
                        title: { text: "Nilai Rupiah (IDR)", style: { color: colors[0] } },
                        labels: {
                            style: { colors: colors[0] },
                            formatter: val => formatToJuta(val, "id-ID")
                        }
                    },
                    {
                        opposite: true,
                        title: { text: "Nilai Dollar (USD)", style: { color: colors[1] } },
                        labels: {
                            style: { colors: colors[1] },
                            formatter: val => formatToJuta(val, "en-US")
                        }
                    }
                ],
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: [
                        { formatter: val => formatCurrencyToJuta(val, "id-ID", "IDR") },
                        { formatter: val => formatCurrencyToJuta(val, "en-US", "USD") }
                    ]
                },
                grid: { strokeDashArray: 4, borderColor: "#e0e0e0" }
            },
            series: [
                {
                    name: "Nilai Rupiah (IDR)",
                    data: data.map(item => item?.NILAIIDR || 0),
                    type: "line"
                },
                {
                    name: "Nilai Dollar (USD)",
                    data: data.map(item => item?.NILAIUSD || 0),
                    type: "line",
                    yAxisIndex: 1
                }
            ]
        };
    }, [data, xAxis, colors]);

    if (!chartConfig) return <p>Data tidak tersedia</p>;

    return (
        <Chart
            options={chartConfig.options}
            series={chartConfig.series}
            type="line"
            height={245}
        />
    );
}
